import { useState } from "react";
import { PRODUCTS, CATEGORIES, IMG } from "@/lib/products";
import { useLang } from "@/lib/i18n";
import { PageHero } from "@/components/PageBits";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export default function Products() {
  const { t } = useLang();
  const [active, setActive] = useState("All");
  const list = active === "All" ? PRODUCTS : PRODUCTS.filter((p) => p.category === active);

  return (
    <div>
      <PageHero
        eyebrow={t("productsPage.eyebrow")}
        title={t("productsPage.title")}
        subtitle={t("productsPage.subtitle")}
        image={IMG.factory}
      />

      <section className="container-x py-16 md:py-24" data-testid="products-page">
        <div className="mb-12 flex flex-wrap gap-3" data-testid="category-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`filter-${c.toLowerCase()}`}
              className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ${
                active === c
                  ? "bg-forest text-sand shadow-md shadow-forest/20"
                  : "border border-hairline bg-surface text-subtle hover:border-forest hover:text-forest"
              }`}
            >
              {t(`categories.${c}`)}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 0.06}>
              <ProductCard product={p} />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
